module.exports = __webpack_public_path__ + "static/media/bamburgh-react-admin-dashboard-reactstrap-pro.2b4f04cf.jpg";